__webpack_require__.p = "https://cdn.reflexivity.com/50ab92fcad88a3465d4470da7d77296849b72ba9/terminal/";